import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

const DashboardIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0' />
    <path d='M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
    <path d='M13.41 10.59l2.59 -2.59' />
    <path d='M7 12a5 5 0 0 1 5 -5' />
  </Icon>
);

export default DashboardIcon;
